module.exports = __webpack_public_path__ + "static/img/janaki.8d1b074d.jpg";